import { render } from "./OrderDetails.vue?vue&type=template&id=11703217&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"

import "./OrderDetails.vue?vue&type=style&index=0&id=11703217&lang=scss&scoped=true"
import "./OrderDetails.vue?vue&type=style&index=1&id=11703217&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11703217"]])

export default __exports__